import React from 'react';
import * as TELEMETRY from '../App/Constants/Telemetry';
import { RESOURCE_TELEMETRY_PROPERTIES } from '../App/Constants/Resources';
import DocumentStore from '../App/Stores/DocumentStore';
import DocumentListItem from '../App/Models/DocumentListItem';
import PictureAsPdf from '@material-ui/icons/PictureAsPdf';

interface Props {
  documentStore: DocumentStore;
  document: DocumentListItem;
  resourceSection: string;
}

class DocumentDownloader extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(doc: DocumentListItem): void {
    const { documentStore, resourceSection } = this.props;
    if (!documentStore || !doc.id) {
      return;
    }

    window.telemetry.logEvent(TELEMETRY.EVENTS.DOWNLOAD_RESOURCE_DOCUMENT, undefined, {
      [RESOURCE_TELEMETRY_PROPERTIES.RESOURCE_SECTION]: resourceSection,
      [RESOURCE_TELEMETRY_PROPERTIES.RESOURCE_DOCUMENT_ID]: doc.id,
      [RESOURCE_TELEMETRY_PROPERTIES.RESOURCE_DOCUMENT_NAME]: doc.name,
    });

    documentStore.getDocument(doc.id).then(async (result) => {
      const data = result && result.data;
      if (!data) {
        return;
      }
      const url = URL.createObjectURL(data);
      const downloadLink = window.document.createElement('a');
      downloadLink.href = url;
      downloadLink.target = '_blank';
      downloadLink.download = doc.name || 'unknown';
      downloadLink.click();
      window.URL.revokeObjectURL(url);
    });
  }

  cleanupName(name: string) {
    let result = name.replaceAll('_', ' ');
    result = result.replace('.pdf', '');
    if (result.length > 70) {
      result = result.substring(0, 67).concat('...');
    }

    return result;
  }

  render() {
    const { document } = this.props;
    return (
      <div className="c-documents__list-document-download">
        <div className="c-documents__list-document-download-flex-container">
          <div className="c-documents__list-document-download-icon-container">
            <PictureAsPdf className="c-documents__list-document-download-icon" />
          </div>
          <div className="c-documents__list-document-download-name-container">
            {this.cleanupName(document.name)}
          </div>
        </div>
        <div
          className="c-documents__list-document-download-button-container"
          onClick={() => document && this.handleClick(document)}
        >
          <div className="c-documents__list-document-download-button">DOWNLOAD</div>
        </div>
      </div>
    );
  }
}

export default DocumentDownloader;
